<template>
<div class="bg-white p-3 rounded">
    <slot></slot>
</div>
</template>

<script>
export default {

}
</script>